import { render } from "./TokenPaymentSuccessId.vue?vue&type=template&id=6b983a66&scoped=true"
import script from "./TokenPaymentSuccessId.vue?vue&type=script&lang=js"
export * from "./TokenPaymentSuccessId.vue?vue&type=script&lang=js"

import "./TokenPaymentSuccessId.vue?vue&type=style&index=0&id=6b983a66&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b983a66"]])

export default __exports__